import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSetTable } from "../InfoSets/InfoSetTable";
import { CdpEntry, CdpTable } from "../Core/CdpTable";
import { Device } from "../Core/Device";
import { IfEntry, IfTable } from "../InfoSets/IfTable";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { HashSet } from "../Utils/HashSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class IfCdpTable extends InfoSetTable<number, CdpTable>
{
	constructor(device: Device) {
		super(device);
	}

	public AddByIndex(ifIndex: number, deviceIndex: string ): CdpEntry {
		var cdpEntry: CdpEntry = null;

		if (ifIndex >= 0) {
			var cdpTable: CdpTable = null;

			if (this._table.ContainsKey(ifIndex)) {
				cdpTable = this._table.Item(ifIndex);
				cdpEntry = cdpTable.Add(ifIndex, deviceIndex);
			}
			else {
				cdpTable = new CdpTable();
				cdpEntry = cdpTable.Add(ifIndex, deviceIndex);

				this._table.Add(ifIndex, cdpTable);
			}
		}

		return (cdpEntry);
	}

	public AddEntry(cdpEntry: CdpEntry): void {
		var cdpTable: CdpTable = null;

		if (this._table.ContainsKey(cdpEntry.IfIndex)) {
			cdpTable = this._table.Item(cdpEntry.IfIndex);
			cdpTable.AddEntry(cdpEntry);
		}
		else {
			cdpTable = new CdpTable();
			cdpTable.AddEntry(cdpEntry);

			this._table.Add(cdpEntry.IfIndex, cdpTable);
		}
	}

	public RemoveByIndex(ifIndex: number, deviceIndex: string):boolean {
		var cdpTable: CdpTable = this._table.Item(ifIndex);
		if(cdpTable)
			return cdpTable.Remove(ifIndex, deviceIndex);
	}
        
	public ClearRemoteCache(): void {
		this._table.ForEach((pair) => {
			pair.Value.ClearRemoteCache();
		});
	}
        

	public Find(ifIndex: number, deviceIndex: string): CdpEntry {
		var cdpEntry: CdpEntry = null;

		if (ifIndex >= 0) {
			var cdpTable: CdpTable = null;

			cdpTable = this._table.Item(ifIndex);
			if(cdpTable){
				cdpEntry = cdpTable.Find(ifIndex, deviceIndex);
			}
		}

		return (cdpEntry);
	}

	public HasRemoteSighting(localIfEntry: IfEntry, remoteDevice: Device, remoteIfEntry: IfEntry):boolean {
		if (localIfEntry == null)
			return false;

		var hasSighting = false;

		this._table.ForEach((pair) => {
			pair.Value.ForEach((cdpEntry) => {
				if (cdpEntry.IfIndex != localIfEntry.IfIndex)
					return;
				if (cdpEntry.RemoteDevice != remoteDevice)
					return;
				if (cdpEntry.RemoteIfEntry != remoteIfEntry)
					return;

				hasSighting = true;
			});
		});

		return hasSighting;
	}

	public get HasIpSightings(): boolean {
		return true;
	}

	public get IpSightings(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		this._table.ForEach((pair) => {
			pair.Value.ForEach((cdpEntry) => {
				if (!cdpEntry.HasRemoteIpAddress)
					return;
				if (!cdpEntry.RemoteIpAddress.IsValidDiscoveryAddress)
					return;

				ipAddresses.Add(cdpEntry.RemoteIpAddress);
			});
		});

		return (ipAddresses);
    }

    //public DeserializeEntry(json: CdpEntryJson): void {
    //    var entry = this.AddByIndex(parseInt(json.if_index), json.device_index);
    //    entry.Deserialize(json);
    //}

    //public EntryName(): string {
    //    return "cdp_entry";
    //};

    //public static FromJson(json: any, device: Device): IfCdpTable {
    //    var result = new IfCdpTable(device);
    //    result.Deserialize(json);
    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.if_cdp_info = {};
		obj = obj.if_cdp_info;

		obj.entries = [];
		this._table.Values().ForEach((cdpTable: CdpTable) => {
			cdpTable.ForEach((cdpEntry: CdpEntry) => {
				let elem: any = {
					cdp_entry: {
						if_index: ValueEncoder.EncodeInteger(cdpEntry.IfIndex),
						device_index: cdpEntry.DeviceIndex
					}
				};

				// REMOTE 
				if (cdpEntry.HasRemoteIpAddress)
					elem.cdp_entry.remote_ip_address = ValueEncoder.EncodeIpAddress(cdpEntry.RemoteIpAddress);

				if (cdpEntry.HasRemoteDeviceId)
					elem.cdp_entry.remote_device_id = cdpEntry.RemoteDeviceId;

				if (cdpEntry.HasRemoteDevicePort)
					elem.cdp_entry.remote_device_port = cdpEntry.RemoteDevicePort;

				if (cdpEntry.HasRemoteVersion)
					elem.cdp_entry.remote_version = cdpEntry.RemoteVersion;

				if (cdpEntry.HasRemotePlatform)
					elem.cdp_entry.remote_platform = cdpEntry.RemotePlatform;

				if (cdpEntry.HasRemoteCapabilities)
					elem.cdp_entry.remote_capabilities = cdpEntry.RemoteCapabilities;

				if (cdpEntry.HasRemoteSysName)
					elem.cdp_entry.remote_system_name = cdpEntry.RemoteSysName;

				if (cdpEntry.HasRemoteSysOID)
					elem.cdp_entry.remote_system_oid = cdpEntry.RemoteSysOID;

				if (cdpEntry.HasRemoteLocation)
					elem.cdp_entry.remote_location = cdpEntry.RemoteLocation;

				obj.entries.push(elem);
			}, this);
		}, this);
    }

    public ForEach(callbackfn: (value: CdpTable, index: number, array: CdpTable[]) => void, thisArg?: any): void {
        this._table.Values().ForEach(callbackfn, thisArg);
    }

	public Read(obj: any, context: any): void {
		if (!obj.if_cdp_info)
			throw new Error();
		obj = obj.if_cdp_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((elem: any) => {
				if (!elem.cdp_entry)
					throw new Error();
				elem = elem.cdp_entry;

				let cdpEntry = new CdpEntry();

				if (elem.if_index !== undefined) {
					cdpEntry.IfIndex = ValueEncoder.DecodeInteger(elem.if_index);
				}

				if (elem.device_index !== undefined) {
					cdpEntry.DeviceIndex = elem.device_index;
				}

				if (elem.remote_ip_address !== undefined) {
					cdpEntry.RemoteIpAddress = ValueEncoder.DecodeIpAddress(elem.remote_ip_address);
				}

				if (elem.remote_device_id !== undefined) {
					cdpEntry.RemoteDeviceId = obj.remote_device_id;
				}

				if (elem.remote_device_port !== undefined) {
					cdpEntry.RemoteDevicePort = elem.remote_device_port;
				}

				if (elem.remote_version !== undefined) {
					cdpEntry.RemoteVersion = elem.remote_version;
				}

				if (elem.remote_platform !== undefined) {
					cdpEntry.RemotePlatform = elem.remote_platform;
				}

				if (elem.remote_capabilities !== undefined) {
					cdpEntry.RemoteCapabilities = elem.remote_capabilities;
				}

				if (elem.remote_system_name !== undefined) {
					cdpEntry.RemoteSysName = elem.remote_system_name;
				}

				if (elem.remote_system_oid !== undefined) {
					cdpEntry.RemoteSysOID = elem.remote_system_oid;
				}

				if (elem.remote_location !== undefined) {
					cdpEntry.RemoteLocation = elem.remote_location;
				}

				this.AddEntry(cdpEntry);
			}, this);
		}
	}
}
